
import { UseFormReturn } from "react-hook-form";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  FormDescription,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { ProcurementFormValues } from "../schema";

interface PaymentTermDaysFieldProps {
  form: UseFormReturn<ProcurementFormValues>;
}

export const PaymentTermDaysField = ({ form }: PaymentTermDaysFieldProps) => {
  return (
    <FormField
      control={form.control}
      name="payment_term_days"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Payment Term (Days)</FormLabel>
          <FormDescription>
            Number of days after delivery when payment is due
          </FormDescription>
          <FormControl>
            <Input
              type="number"
              min="0"
              {...field}
              onChange={e => field.onChange(parseInt(e.target.value) || 0)}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
